// i18n area 'system' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da system.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/system.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './system'

export const enGB: DeepPartial<typeof enUS> = {
  explorer: {
    kinds: {
      catalogFile: 'Catalogue file'
    }
  },
  sysinfo: {
    summary: 'Platform versions across the cluster, the components each node runs, the administration manual and the licence.'
  },
  licensing: {
    title: 'Cluster licence',
    subtitle: 'Subscription licence — at most one per cluster',
    absentTitle: 'No licence registered',
    absentBody: 'Without a valid licence the cluster refuses to start new virtual machines (running VMs are untouched). Register the product key that came with your subscription.',
    registerButton: 'Register licence',
    removeButton: 'Remove licence',
    gateNote: 'With the licence absent, expired or beyond its limit the cluster refuses to start NEW virtual machines. Running VMs stay up and HA restarts are unaffected.',
    dialogTitle: 'Register licence',
    dialogExpiresHelp: 'Empty = the licence never expires',
    dialogError: 'Could not register the licence.',
    removeTitle: 'Remove licence',
    removeBody: 'The cluster will run UNLICENSED: new virtual machines will refuse to start until a licence is registered. Running VMs are untouched.',
    removeError: 'Could not remove the licence.'
  },
  users: {
    mfa: {
      enrollableChip: 'Enrolment in TVirt',
      statePending: 'Awaiting enrolment',
      noMethods: 'No enrolment',
      resetHint: 'The enrolment and every recovery code are wiped: at the next login the user enrols again from scratch. The MFA obligation stays as it is — an administrator never sets a secret, they only clear it.',
      externalTitle: 'External enrolments',
      externalEmpty: 'No external enrolment yet — one is born at the first login of a directory identity under the MFA obligation.',
      orphanHelp: 'An orphaned enrolment is never deleted on its own: it is security material — it stays for the audit and, if the identity reappears in the directory, it finds its factor again. The only way out is the administrative reset.',
      visibilityHint: 'External enrolments reside at the cluster root: only who holds user.read over the whole tree sees them.',
      orphanResetHint: 'The orphaned row is removed for good: nobody claims it any more. If the identity ever comes back to the directory, it will enrol again from scratch.',
      enforcingSubtitle: 'The anchor of the obligation for external identities is the group: its realm mappings say which directory population it reaches. The external enrolment is born at the first login of the obligated user.'
    }
  }
}
